import React from "react";

interface AddBannerContextType {
    jwtToken: any;
    setJwtToken: (jwtToken: any) => void;
    prevState: any;
    setUserToken: (options: any) => void;
    addNewBanner: (options: any) => void;
    clientToken: any;
    primaryMemory: any;
}

const AddBannerContext = React.createContext<AddBannerContextType | undefined>(undefined);

export default AddBannerContext;